import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white rounded-t-2xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Left Column */}
          <div className="space-y-6">
            <div>
              <img 
                src="https://static.readdy.ai/image/72f6c186dba6e85b29149b12cdad4e19/8634dd506c02412618be9c7eeb5f8b42.png" 
                alt="NEXIT" 
                className="h-8 w-auto brightness-0 invert"
              />
              <p className="text-sm text-gray-light mt-3">
                Strategy • Social • AI • Experience • Influencer
              </p>
            </div>
          </div>

          {/* Middle Column */}
          <div>
            <h4 className="text-xs uppercase text-gray-light mb-4 tracking-wider">
              HİZMETLER
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/strategy" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  Strategy
                </Link>
              </li>
              <li>
                <Link to="/social-media" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  Social Media
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  Influencer Marketing
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  AI Studio
                </a>
              </li>
              <li>
                <a href="#" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  Experience
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div>
            <h4 className="text-xs uppercase text-gray-light mb-4 tracking-wider">
              İLETİŞİM
            </h4>
            <ul className="space-y-3 mb-6">
              <li>
                <a href="tel:+905551234567" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  
                </a>
              </li>
              <li>
                <a href="mailto:info@nexitnewmedia.com" className="text-sm hover:underline cursor-pointer whitespace-nowrap">
                  info@nexitnewmedia.com
                </a>
              </li>
            </ul>
            
            {/* Social Icons */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/nexit.newmedia/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center hover:bg-white/10 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-light">
            © {currentYear} NEXIT New Media. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs hover:underline cursor-pointer whitespace-nowrap">
              KVKK
            </a>
            <a href="#" className="text-xs hover:underline cursor-pointer whitespace-nowrap">
              Çerez Politikası
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs hover:underline cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
